import { render, staticRenderFns } from "./addPaymentAdapt.vue?vue&type=template&id=7664cb88"
import script from "./addPaymentAdapt.vue?vue&type=script&lang=js"
export * from "./addPaymentAdapt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports